<template>
  <el-col :span="(fieldOne.type == 9 || fieldOne.type == 12 || fieldOne.type == 13|| fieldOne.type == 16|| fieldOne.type == 5)?24:8" v-if="fieldIfShow()" >
    <el-form-item :label="fieldOne.cnName">
      <template slot="label">
        <span :style="fieldOne.ifMust==1?'color:red;':''">{{(fieldOne.ifMust==1?'*':'')+fieldOne.cnName + ':'}}</span>
      </template>
      <!-- 数据字典 -->
      <template v-if="fieldOne.type == 1">
        <el-select @change="fieldValueChange"
          v-model="value[fieldOne.enName]" clearable
          :multiple="false" 
        >
          <template v-for="(dicOne,dicIndex) in fieldOne.dicList">
            <el-option :key="'dic_'+dicIndex" v-if="dicOne.ifHide!=1" :label="dicOne.label" :value="dicOne.value"></el-option>
          </template>
        </el-select>
        <template v-for="(dicOne) in fieldOne.dicList">
          <template v-if="dicOne.value == value[fieldOne.enName]">
            {{dicOne.remark}}
          </template>    
        </template>
      </template>
      <!-- 字符类型 -->
      <template v-else-if="fieldOne.type == 2">
        <template v-if="fieldOne.inputArr">
          <el-input v-for="(inputOne,inputIndex) in fieldOne.inputArr" :key="'input_'+inputIndex" type="text" v-model="value[inputOne.enName]" :placeholder="inputOne.placeholder" @change="fieldValueChange" :disabled="inputOne.ifUpdate==1?true:false"></el-input>
        </template>
        <el-input v-else type="text" v-model="value[fieldOne.enName]" :placeholder="fieldOne.placeholder" ></el-input>
      </template>
      <!-- 图片类型 -->
      <template v-else-if="fieldOne.type == 3">
        <el-select v-model="value[fieldOne.enName]" clearable :multiple="false"  @change="fieldValueChange"
        >
          <el-option  v-for="(one,index) in ImageList"  :key="'nameBgimage_'+index" :label="one.NAME" :value="one.BG_URL"
          ></el-option>
        </el-select>
      </template>
      <!-- 值插件类型 -->
      <template v-else-if="fieldOne.type == 4 || fieldOne.type == 17">
        <ValuePlug :tableId="valuePlugTableInfo.tableId+''" v-model="value[fieldOne.enName]" :sourceType="0" :ifSavePlug="false" @callback="fieldValueChange"></ValuePlug>
      </template>
      <!-- 富文本类型 -->
      <template v-else-if="fieldOne.type == 5">
        <el-input type="textarea" :disabled="fieldOne.ifUpdate==1?true:false" v-model="value[fieldOne.enName]" :placeholder="fieldOne.placeholder"></el-input>
        <span v-if="fieldOne.remark">{{fieldOne.remark}}</span>
      </template>
      <!-- 条件插件类型 -->
      <template v-else-if="fieldOne.type == 6">
        <TjPlug :tableId="TjPlugTableInfo.tableId+''" v-model="value[fieldOne.enName]" :xnTableId="TjPlugTableInfo.xnTableId+''" :sourceType="0" :ifSavePlug="false" @callback="fieldValueChange"></TjPlug>
      </template>
      <!-- 页面选择 7  14:所有页面 -->
      <template v-else-if="fieldOne.type == 7 || fieldOne.type == 11 || fieldOne.type == 14 || fieldOne.type == 19">
        <el-select v-model="value[fieldOne.enName]" filterable reserve-keyword placeholder="请输入关键词" clearable :loading="tableObjectloading"  @change="fieldValueChange">
          <!-- remote :remote-method="(query)=>loadTableObject(1,query)" -->
          <el-option
            v-for="goalTableOne in objectArr"
            :key="goalTableOne.value"
            :label="goalTableOne.text"
            :value="goalTableOne.value" >
          </el-option>
        </el-select>
        <el-button v-if="fieldOne.ifZdyAddPage==1" type="primary" @click="showAddPage">新增</el-button>
        <el-input v-if="addPageInfo.ifShow" type="text" v-model="addPageInfo.pageName" :placeholder="fieldOne.placeholder" ><el-button slot="append" v-loading="addPageInfo.loading" icon="el-icon-circle-plus-outline" @click="addNewPage"></el-button></el-input>
      </template>
      <template v-else-if="fieldOne.type == 18">
        <el-select v-model="value[fieldOne.enName]" filterable reserve-keyword placeholder="请输入关键词" clearable :loading="tableObjectloading" value-key="value"  @change="fieldValueChange">
          <!-- remote :remote-method="(query)=>loadTableObject(1,query)" -->
          <el-option
            v-for="goalTableOne in objectArr"
            :key="goalTableOne.value"
            :label="goalTableOne.text"
            :value="goalTableOne">
          </el-option>
        </el-select>
        <el-button v-if="fieldOne.ifZdyAddPage==1" type="primary" @click="showAddPage">新增</el-button>
        <el-input v-if="addPageInfo.ifShow" type="text" v-model="addPageInfo.pageName" :placeholder="fieldOne.placeholder" ><el-button slot="append" v-loading="addPageInfo.loading" icon="el-icon-circle-plus-outline" @click="addNewPage"></el-button></el-input>
      </template>

      <!-- 对象选择 8 -->
      <template v-else-if="fieldOne.type == 8">
        <el-select v-model="value[fieldOne.enName]" filterable reserve-keyword placeholder="请输入关键词" clearable :loading="tableObjectloading"  value-key="tableId"  @change="fieldValueChange">
          <!-- remote :remote-method="(query)=>loadTableObject(1,query)" -->
          <el-option
            v-for="goalTableOne in objectArr"
            :key="goalTableOne.tableId"
            :label="goalTableOne.tableCnName"
            :value="{tableId:goalTableOne.tableId,tableCnName:goalTableOne.tableCnName}" >
          </el-option>
        </el-select>
      </template>

      <!-- 数组 9 -->
      <template v-else-if="fieldOne.type == 9">
        <el-button type="primary" icon="el-icon-plus" circle @click="addFieldOne(fieldOne)"></el-button>
        <el-row v-for="(valueOne,valueOneIndex) in value[fieldOne.enName]" :key="'child_field_arr_'+valueOneIndex" type="flex" style="flex-wrap:wrap;"  >
          <template v-for="(childFieldOne,childFieldIndex) in fieldOne.fieldArr">
            <OneFieldSet :key="'field_childField_' + valueOneIndex + '_' +childFieldIndex" :fieldOne="childFieldOne" v-model="value[fieldOne.enName][valueOneIndex]" :parentValue="value" :ImageList="ImageList" :tableId="tableId" :relationTableId="relationTableId"  @fieldValueChange="fieldValueChange"></OneFieldSet>
          </template>
          <el-button :key="'field_deleteChildField_' + valueOneIndex" type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteFieldOne(fieldOne,valueOneIndex)" style="height:40px;"></el-button>
        </el-row>
      </template>

      <!-- 字段选择 -->
      <template v-else-if="fieldOne.type == 10">
        <el-select v-model="value[fieldOne.enName]" filterable reserve-keyword placeholder="请输入关键词" clearable :loading="tableObjectloading"  value-key="fieldId"  @change="fieldValueChange">
          <!-- remote :remote-method="(query)=>loadTableObject(1,query)" -->
          <el-option
            v-for="goalTableOne in objectArr"
            :key="goalTableOne.fieldId"
            :label="goalTableOne.fieldCnName"
            :value="goalTableOne">
          </el-option>
        </el-select>
      </template>

      <!-- 字段列表 -->
      <template v-else-if="fieldOne.type == 12">
        <el-select @change="plChangeIfDelete"
          v-model="ifDelete" clearable
          :multiple="false" 
        >
          <el-option v-for="(dicOne,dicIndex) in fieldOne.fieldArr[1].dicList" :key="'dic_'+dicIndex" :label="dicOne.label" :value="dicOne.value"></el-option>
        </el-select>
        <el-row v-for="(valueOne,valueOneIndex) in value[fieldOne.enName]" :key="'child_field_arr_'+valueOneIndex" type="flex" style="flex-wrap:wrap;">
          <template v-for="(childFieldOne,childFieldIndex) in fieldOne.fieldArr">
            <OneFieldSet :key="'field_childField_' + valueOneIndex + '_' +childFieldIndex" :fieldOne="childFieldOne" v-model="value[fieldOne.enName][valueOneIndex]" :parentValue="value" :ImageList="ImageList" :tableId="tableId" :relationTableId="relationTableId"  @fieldValueChange="fieldValueChange"></OneFieldSet>
            <!-- <el-button :key="'field_deleteChildField_' + valueOneIndex + '_' +childFieldIndex" type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteFieldOne(fieldOne,valueOneIndex)"></el-button> -->
          </template>
        </el-row>
      </template>
      <!-- 自定义触发器 -->
      <template v-else-if="fieldOne.type == 13">
        <el-button type="primary" @click="openDirectButtonSet">自定义触发器</el-button>
      </template>
      <!-- 数据字典选择 -->
      <template v-else-if="fieldOne.type == 15">
        <el-select v-model="valueArr" filterable reserve-keyword placeholder="请输入关键词" clearable :loading="tableObjectloading"  value-key="fieldId"  :multiple="(fieldOne.multipleEnName && value[fieldOne.multipleEnName]==16)?false:true" @change="selectMultipleChange">
          <!-- remote :remote-method="(query)=>loadTableObject(1,query)" -->
          <template v-for="goalTableOne in objectArr">
            <el-option :key="goalTableOne.DIC_ID"
              v-if="!fieldOne.dicFilterEnName || !(value[fieldOne.dicFilterEnName]) || ((','+value[fieldOne.dicFilterEnName]+',').indexOf(','+goalTableOne.DIC_ID+',')>=0)"
              :label="goalTableOne.DIC_NAME"
              :value="goalTableOne.DIC_ID+''" >
            </el-option>
          </template>
        </el-select>
      </template>
      <!-- 子表格页面 -->
      <template v-else-if="fieldOne.type == 16">
        <el-button type="primary" @click="openSetChildPage">设置子表格:({{value[fieldOne.enName]}})</el-button>
      </template>
    </el-form-item>
    <el-dialog v-if="addChildPageFlag" title="子表格字段设置" :visible.sync="addChildPageFlag" width=98% top="1vh" :close-on-press-escape="false" :close-on-click-modal="false" center append-to-body>
      <LookFieldSet v-if="childPageInfo.ifLoad" v-model="childPageInfo" :isChild="1"></LookFieldSet>
      <span slot="footer">
        <el-button type="primary" @click="saveChildPage">保存:({{value[fieldOne.enName]}})</el-button>
        <el-button type="primary" @click="openSetChildPage">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="addDialogFlag" title="自定义触发器" :visible.sync="addDialogFlag" width=98% top="1vh" center append-to-body>
      <template v-for="(blockOne,blockIndex) in basicBlockArr" >
        <template v-if="(!blockOne.filterName || (blockOne.filterType==1 && (','+blockOne.filterValue+',').indexOf(','+directButtonSetValue[blockOne.filterName]+',')>=0) || (blockOne.filterType==2 && (','+blockOne.filterValue+',').indexOf(','+directButtonSetValue[blockOne.filterName]+',')==-1))">
          <div :key="'block_basic_'+blockIndex">
            {{blockOne.blockCnName}}:
            <el-button v-if="blockOne.blockType==2" type="primary" icon="el-icon-plus" circle @click="addBlockField(blockOne)"></el-button>
            <el-row v-if="blockOne.blockType!=2" type="flex" style="flex-wrap:wrap;"  >
              <template v-for="(fieldOne,fieldIndex) in blockOne.fieldArr">
                <OneFieldSet :key="'block_field_'+fieldIndex + '_' + (fieldOne.appendIndex?fieldOne.appendIndex:'')" :fieldOne="fieldOne" v-model="directButtonSetValue" :ImageList="ImageList" :tableId="tableId" :relationTableId="relationTableId" @fieldValueChange="fieldValueChange"></OneFieldSet>
              </template>
            </el-row>
            <template v-else>
              <el-row v-for="(valueOne,valueOneIndex) in directButtonSetValue[blockOne.blockEnName]" :key="'block_arr_'+valueOneIndex" type="flex" style="flex-wrap:wrap;"  >
                <template v-for="(fieldOne,fieldIndex) in blockOne.fieldArr">
                  <OneFieldSet :key="'block_field_'+fieldIndex + '_' + (fieldOne.appendIndex?fieldOne.appendIndex:'')" :fieldOne="fieldOne" v-model="directButtonSetValue[blockOne.blockEnName][valueOneIndex]" :ImageList="ImageList" :tableId="tableId" :relationTableId="relationTableId" @fieldValueChange="fieldValueChange"></OneFieldSet>
                </template>
                <el-button :key="'block_delete_field_'+valueOneIndex" type="primary" icon="el-icon-delete-solid" circle style="height:40px;"  @click="toDeleteFieldDataOne(blockOne,valueOneIndex)"></el-button>
              </el-row>
            </template>
          </div>
        </template>
      </template>
      <span slot="footer">
        <el-button type="primary" @click="dialogIframeZdyConfirm">保 存</el-button>
      </span>
    </el-dialog>
  </el-col>
            
</template>

<script>
import CommonStyleSet from '@/components/page/pageSet/CommonStyleSet.vue';
import ValuePlug from '@/components/page/pageUtil/ValuePlug.vue';
import TjPlug from '@/components/page/pageUtil/TjPlug.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'OneFieldSet',
  props: {
    value: {
      type:Object,
      default(){
        return {}
      }
    },
    parentValue:{
      type:Object,
      default(){
        return {}
      }
    },
    fieldOne:{
      type:Object,
      default(){
        return {}
      }
    },
    ImageList:{
      type:Array
    },
    tableId:{
      type:Number
    },
    relationTableId:{
      type:Number
    },
    pageId:{
      type:Number
    },
    pageName:{
      type:String,
      default:""
    },
  },
  data() {
    var that = this;
    return {
      objectArr:[],
      valueArr:[],
      tableObjectloading:false,
      //直接操作的mongo信息
      directButtonSetValue:{
        directSetList:[]
      },
      oldFilterValue:{},
      oldFilterEnNameValue:null,
      addDialogFlag:false,
      addChildPageFlag:false,
      basicBlockArr:[{
        blockCnName:"基础设置",
        blockEnName:"directSetList",
        blockType:2,
        fieldArr:[{
          cnName:"触发器类型",enName:"type",type:1,
          dicList:[{label:"添加",value:1},{label:"修改",value:2},{label:"删除",value:3},{label:"导入",value:9},{label:"批量修改",value:10}]
        },{
          cnName:"触发器状态",enName:"trigger_state",type:1,
          dicList:[{label:"启用",value:"1"},{label:"禁用",value:"0"}]
        },{
          cnName:"执行顺序",enName:"triggerOrder",type:1,
          dicList:[{label:"1",value:"1"},{label:"2",value:"2"},{label:"3",value:"3"},{label:"4",value:"4"},{label:"5",value:"5"},{label:"6",value:"6"},{label:"7",value:"7"},{label:"8",value:"8"},{label:"9",value:"9"}]
        },{
          cnName:"执行Sql",enName:"sqlInfo",type:9,
          fieldArr:[{
              cnName:"操作名称",enName:"name",type:2,placeholder:''
            },{
              cnName:"执行操作",enName:"sqlType",type:1,
              dicList:[{label:"添加",value:1},{label:"修改",value:2},{label:"删除",value:3}]
            },{
              cnName:"SQL",enName:"sql",type:5,placeholder:''
          }]
        }]
      }],
      //是否新增页面
      addPageInfo:{
        ifShow:false,
        pageName:"",
        tableId:0,
        pageType:0,
        loading:false
      },
      //当是添加修改页面时,子表格的页面信息
      childPageInfo:{
        "pageId":0,
        "pageType" : 7,
        "tableId" : 0,
        "isChild" : 1,
        "pageDiaLogId" : 0,
        "addFieldSet":[],
        "hideFieldSet":[],
        "relationTableId":0,
        "ifLoad":false
      },
      TjPlugTableInfo:{
        tableId:that.tableId,
        xnTableId:that.tableId
      },
      valuePlugTableInfo:{
        tableId:that.tableId,
      },
      //是否删除
      ifDelete:0
    };
  },
  created() {
    this.initCreate();
  },
  mounted() {
  },
  watch:{
    value:{
      handler(newValue){
        if(this.fieldOne.filterName) {
          if(typeof(this.fieldOne.filterName) == 'string') {
            if(this.oldFilterValue[this.fieldOne.filterName] != newValue[this.fieldOne.filterName]) {
              this.initCreate();
              this.oldFilterValue[this.fieldOne.filterName] = this.value[this.fieldOne.filterName];
            }
          } else {
            for (let index = 0; index < this.fieldOne.filterName.length; index++) {
              var filterName1 = this.fieldOne.filterName[index];
              if(this.oldFilterValue[filterName1] != newValue[filterName1]) {
                this.initCreate();
                this.oldFilterValue[filterName1] = this.value[filterName1];
              }
            }
          }
        }
        if(this.fieldOne.filterEnName && this.fieldOne.filterFieldEnName) {
          if(newValue[this.fieldOne.filterEnName]) {
            if(this.oldFilterEnNameValue != newValue[this.fieldOne.filterEnName][this.fieldOne.filterFieldEnName]) {
              this.initCreate();
              this.oldFilterEnNameValue = this.value[this.fieldOne.filterEnName][this.fieldOne.filterFieldEnName];
            }
          }
        }
      },
      deep:true
    }
  },
  computed:{
  },
  components: {
    CommonStyleSet,
    LookFieldSet:resolve => require(['@/components/page/pageSet/LookFieldSet.vue'], resolve),
    ValuePlug,
    TjPlug
  },
  methods: {
    //字段是否显示
    fieldIfShow:function(){
      var fieldOne = this.fieldOne;
      var value = this.value;
      var flag = true;
      if(fieldOne.filterName) {
        if(typeof(fieldOne.filterName) == 'string') {
          flag = (!fieldOne.filterName || (fieldOne.filterType==1 && (','+fieldOne.filterValue+',').indexOf(','+value[fieldOne.filterName]+',')>=0) || (fieldOne.filterType==2 && (','+fieldOne.filterValue+',').indexOf(','+value[fieldOne.filterName]+',')==-1) || (fieldOne.filterType==3 && value[fieldOne.filterName]) || (fieldOne.filterType==4 && !value[fieldOne.filterName]));
        } else {
          if(fieldOne.filterOrAnd) {
            flag = false;
          }
          for (let index = 0; index < fieldOne.filterName.length; index++) {
            var filterName1 = fieldOne.filterName[index];
            var filterType1 = fieldOne.filterType[index];
            var filterValue1 = fieldOne.filterValue[index];
            var xhflag = (!filterName1 || (filterType1==1 && (','+filterValue1+',').indexOf(','+value[filterName1]+',')>=0) || (filterType1==2 && (','+filterValue1+',').indexOf(','+value[filterName1]+',')==-1) || (filterType1==3 && value[filterName1]) || (filterType1==4 && !value[filterName1]));
            if(!fieldOne.filterOrAnd) {
              if(flag) {
                flag = xhflag;
              }
            } else {
              if(!flag) {
                flag = xhflag;
              }
            }
          }
        }
      }
      return flag;
    },
    initCreate:function(){
      if(this.fieldIfShow()) {
        if(this.fieldOne.type == 7 || this.fieldOne.type == 11 || this.fieldOne.type == 14 || this.fieldOne.type == 18 || this.fieldOne.type == 19) {
            //页面
          this.loadPageObject("");
        } else if(this.fieldOne.type == 8) {
          //对象
          this.loadTableObject("");
        } else if(this.fieldOne.type == 10 || this.fieldOne.type == 12) {
          //字段
          this.loadFieldObject("");
        } else if(this.fieldOne.type == 13) {
          //直接操作触发器sql
        } else if(this.fieldOne.type == 15) {
          //加载数据字典的下拉框值
          this.loadDicListObject("");
        } else if(this.fieldOne.type == 16) {
          //加载子页面的页面信息
          this.loadChildPageObject();
        } else if(this.fieldOne.type == 6) {
          console.log("this.fieldOne======================",this.fieldOne,this.value,this.parentValue);
          var value = this.value;
          if(this.fieldOne.tableIdSourceType == "parent") {
            value = this.parentValue;
          }
          //条件插件
          if(this.fieldOne.filterEnName && this.fieldOne.filterFieldEnName) {
            if(value[this.fieldOne.filterEnName]) {
              this.TjPlugTableInfo.tableId = value[this.fieldOne.filterEnName][this.fieldOne.filterFieldEnName];
            }
          } else {
            this.TjPlugTableInfo.tableId = this.tableId;
          }
          if(this.fieldOne.xnTableIdEnName && this.fieldOne.xnTableIdEnFieldName && value[this.fieldOne.xnTableIdEnName]) {
            this.TjPlugTableInfo.xnTableId = value[this.fieldOne.xnTableIdEnName][this.fieldOne.xnTableIdEnFieldName];
          } else {
            this.TjPlugTableInfo.xnTableId = this.tableId;
          }
        } else if(this.fieldOne.type == 4 || this.fieldOne.type == 17) {
          this.valuePlugTableInfo.tableId = (this.fieldOne.type == 4?this.tableId:this.relationTableId);
          // if(this.fieldOne.filterTableEnName) {
            
          // }
          //;

          
        }
      }
    },
    addFieldOne:function(fieldOne){
      var that = this;
      if(!this.value[fieldOne.enName]) {
        that.$set(that.value, fieldOne.enName, []);
      }
      var addJson = {};
      fieldOne.fieldArr.forEach(childFieldOne => {
        if(childFieldOne.type == 6) {
            //条件插件
            addJson[childFieldOne.enName] = {
                nameStr:"",
                resultStr:"",
                tjPlugId:0
            };
        } else if(childFieldOne.type == 4 || childFieldOne.type == 17){
            //值插件
            addJson[childFieldOne.enName] = {
                nameStr:"",
                resultStr:"",
                valuePlugId:0
            };
        } else {
            addJson[childFieldOne.enName] = null;
        }
      });
      this.value[fieldOne.enName].push(addJson);
      // pageUtils.addBlockField(this,fieldOne);
      console.log("blockOne=========================",fieldOne,this.value);
      this.$forceUpdate();
    },
    fieldValueChange:function(){
      console.log("fieldValueChange===========1111============",this.fieldOne,this.value,this.parentValue);
      this.$emit("fieldValueChange",this.fieldOne);
    },
    selectMultipleChange:function(){
      var that = this;
      if(typeof(that.valueArr) == "string") {
        that.value[that.fieldOne.enName] = that.valueArr;
      } else {
        that.value[that.fieldOne.enName] = that.valueArr.join(",");
      }
      this.fieldValueChange();
    },
    /**
     * 加载对象弹出层信息 
     */
    loadTableObject:function(query){
      console.log("query================",query);
      var that = this;
      var url = "dialog_getAllTableInfo.do";
      var toHtData={};
      that.tableObjectloading = true;
      if (query !== '') {
        toHtData.tableCnNameSearch = query;
      }
      toHtData.start = 0;
      toHtData.limit = "10000_flow";
      toHtData.ifAjaxCount = false;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
              that.objectArr = res.data.rows;
          }
          that.tableObjectloading = false;
        }
      })
    },
    /**
     * 加载页面弹出层信息 
     */
    loadPageObject:function(query){
      console.log("query================",query);
      var that = this;
      var toHtData={};
      var url = "tableSet_getAllListPage.do";
      if(this.fieldOne.type == 11) {
        url = "buttonSet_getListButtonSetPage.do";
      } else if(this.fieldOne.type == 19) {
        url = "buttonSet_getListButtonSetPageGlAdd.do";
      } else if(this.fieldOne.type == 14 || this.fieldOne.type == 18) {
        url = "buttonSet_getAllPageByType.do";
      }
      that.tableObjectloading = true;
      if(that.fieldOne.filterEnName) {
        console.log("that.fieldOne===============",that.fieldOne,that.value);
        if(that.fieldOne.filterFieldEnName) {
          if(that.value[that.fieldOne.filterEnName]) {
            toHtData.tableId = that.value[that.fieldOne.filterEnName][that.fieldOne.filterFieldEnName];
          }
        } else {
          if(that.value[that.fieldOne.filterEnName]) {
            toHtData.tableId = that.value[that.fieldOne.filterEnName].tableId
          }
        }
        console.log("toHtData.tableId===============",toHtData.tableId);
      }
      if(that.fieldOne.filterPageTypeEnName) {
        var tmpPageType = that.value[that.fieldOne.filterPageTypeEnName];
        if(that.fieldOne.filterPageTypeEnName == "buttonType") {
          if(tmpPageType == 12 || tmpPageType == 2) {
            tmpPageType = 7;
          } else if(tmpPageType == 15) {
            tmpPageType = 11;
          } else if(tmpPageType == 18) {
            tmpPageType = 5;
          }
        }
        toHtData.pageType = tmpPageType;
      }
      if(that.fieldOne.filterPageTypeValue) {
        toHtData.pageType = that.fieldOne.filterPageTypeValue
      } 
      that.fieldOne.loadPageType = toHtData.pageType;
      that.addPageInfo.tableId = toHtData.tableId;
      that.addPageInfo.pageType = toHtData.pageType?toHtData.pageType:1;
      toHtData.start = 0;
      toHtData.limit = "10000_flow";
      toHtData.ifAjaxCount = false;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
              that.objectArr = res.data;
          }
          if(that.fieldOne.type == 18) {
            res.data.forEach(tmpField1 =>{
              if(that.value[that.fieldOne.enName] && tmpField1.pageId == that.value[that.fieldOne.enName].pageId) {
                that.value[that.fieldOne.enName] = tmpField1;
              }
            })
            console.log("页面数据加载完成后:",that.value[that.fieldOne.enName]);
          }
          that.tableObjectloading = false;
        }
      })
    },
    /**
     * 加载字段弹出层信息 
     */
    loadFieldObject:function(query){
      var that = this;
      var url = "dialog_getAllFieldInfo.do";
      var toHtData={};
      that.tableObjectloading = true;
      if(that.fieldOne.filterEnName) {
        if(that.fieldOne.filterFieldEnName) {
          toHtData.mainTableId = that.value[that.fieldOne.filterEnName][that.fieldOne.filterFieldEnName];
        } else {
          toHtData.mainTableId = that.value[that.fieldOne.filterEnName].tableId;
          toHtData.showFilterType = that.value[that.fieldOne.filterEnName].showFilterType;
        }
      }
      if(that.fieldOne.filterFieldRole) {
        toHtData.showFilterType = that.fieldOne.filterFieldRole;
      }
      if(that.fieldOne.filterJson) {
        for(var key in that.fieldOne.filterJson) {
          toHtData[key] = that.fieldOne.filterJson[key];
          if(key == "mainTableId") {
            toHtData["mainTableId"] = that.tableId;
          } else if(key == "mainRelationTableId"){
            toHtData["mainTableId"] = that.relationTableId;
          } else if(key == "relationTableId") {
            toHtData["relationTableId"] = that.relationTableId;
          }
        }

      }
      console.log("toHtData=======loadFieldObject==============",toHtData,that.fieldOne,that.relationTableId,that.tableId);
      toHtData.start = 0;
      toHtData.limit = "10000_flow";
      toHtData.ifAjaxCount = false;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
            if(that.fieldOne.type == 12) {
              if(!that.value[that.fieldOne.enName]) {
                var newArr = [];
                res.data.rows.forEach(tmpField1 =>{
                  tmpField1.isDelete = 0;
                  newArr.push(tmpField1);
                })
                that.value[that.fieldOne.enName] = newArr;
              } else {
                var newArr = [];
                that.value[that.fieldOne.enName].forEach(tmpField1 =>{
                  res.data.rows.forEach(tmpField2 =>{
                    if(tmpField1.fieldId == tmpField2.fieldId){
                      newArr.push(tmpField1);
                    }
                  })  
                })
                res.data.rows.forEach(tmpField1 =>{
                  var ifNewAdd = true;
                  that.value[that.fieldOne.enName].forEach(tmpField2 =>{
                    if(tmpField1.fieldId == tmpField2.fieldId){
                      ifNewAdd = false;
                    }
                  })  
                  if(ifNewAdd) {
                    tmpField1.isDelete = 0;
                    newArr.push(tmpField1);
                  }
                })
                that.value[that.fieldOne.enName] = newArr;
              }
            } else {
              if(res.data.rows.length > 0) {
                if(res.data.rows[0].fieldRole == 0) {
                  res.data.rows[0].fieldId = 0;
                  res.data.rows[0].relationTableId = res.data.rows[0].tableId;
                }
                that.objectArr = res.data.rows;
              }
            }
          }
          that.tableObjectloading = false;
        }
      })
    },
    toDeleteFieldOne:function(fieldOne,valueOneIndex){
      this.value[fieldOne.enName].splice(valueOneIndex,1);
      // fieldOne.fieldArr.splice(valueOneIndex,1);
      this.$forceUpdate();
    },
    /**
     * 加载对象弹出层信息 
     */
    loadDirectButtonSetObject:function(query){
      console.log("query================",query);
      var that = this;
      var tmpDirectButtonIdStr = that.value[that.fieldOne.enName];
      if(tmpDirectButtonIdStr) {
        var tmpDirectButtonIdStrArr = tmpDirectButtonIdStr.split(",");
        that.directButtonSetValue.directSetList = [];
        var toHtData = {};
        toHtData.mongoName = "directButtonSet";
        toHtData.mongoIdName = "directButtonSetId";
        toHtData.sourceType = 1;
        tmpDirectButtonIdStrArr.forEach(element => {
          if(element>0) {
            var url = "pageShowSet_loadMongoInfoById.do";
            toHtData.dataId = element;
            that.tableObjectloading = true;
            utils.request(that,{
              url: url, 
              data: toHtData,
              success: function (res) {
                console.log(res.data);
                var tmpJson = {};
                if(res.data) {
                    tmpJson = res.data;
                }
                that.directButtonSetValue.directSetList.push(tmpJson);
                that.tableObjectloading = false;
              }
            })
          }
        });
      }
    },
    /**
     * 加载数据字典的值
     */
    loadDicListObject:function(){
      var that = this;
      if(that.fieldOne.multipleEnName && that.value[that.fieldOne.multipleEnName]==16){
        that.valueArr = that.value[that.fieldOne.enName];
      } else {
        if(that.value[that.fieldOne.enName]) {
          that.valueArr = that.value[that.fieldOne.enName].split(",");
        }
      }
      var toHtData={};
      var url = "addPageSet_findChildDic.do";
      that.tableObjectloading = true;
      if(that.fieldOne.filterEnName) {
        console.log("that.fieldOne===============",that.fieldOne,that.value);
        if(that.value[that.fieldOne.filterEnName]) {
          toHtData.dicParId = that.value[that.fieldOne.filterEnName];
        }
      }
      
      toHtData.start = 0;
      toHtData.limit = "10000_flow";
      toHtData.ifAjaxCount = false;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
              that.objectArr = res.data;
          }
          that.tableObjectloading = false;
        }
      })
    },
    addBlockField:function(blockOne){
      var that = this;
      if(!that.directButtonSetValue[blockOne.blockEnName]) {
        that.$set(that.directButtonSetValue, blockOne.blockEnName, []);
        // this.value[blockOne.blockEnName] = [];
        }
        var addJson = {};
        blockOne.fieldArr.forEach(childFieldOne => {
            if(childFieldOne.type == 6) {
                addJson[childFieldOne.enName] = {
                nameStr:"",
                resultStr:"",
                tjPlugId:0
                };
            } else {
                addJson[childFieldOne.enName] = null;
            }
        });
        that.directButtonSetValue[blockOne.blockEnName].push(addJson);
        console.log("blockOne=========================",blockOne,this.directButtonSetValue);
        that.$forceUpdate();
    },
    toDeleteFieldDataOne:function(blockOne,valueOneIndex){
      this.directButtonSetValue[blockOne.blockEnName].splice(valueOneIndex,1);
      this.$forceUpdate();
    },
    /**
     * 打开直接操作的设置
     */
    openDirectButtonSet:function(){
      this.addDialogFlag = true;
      //直接操作触发器sql
      this.loadDirectButtonSetObject("");
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      var tmpDirectButtonIdStr = "";
      that.directButtonSetValue.directSetList.forEach(element => {
        //循环进行保存 并记录id
        element.ifSaveSuccess = false;
        var toHtData = {};
        toHtData.mongoName = "directButtonSet";
        toHtData.mongoIdName = "directButtonSetId";
        toHtData.sourceType = 1;
        var url = "pageShowSet_saveMongoInfoById.do";
        toHtData.dataId = element.directButtonSetId;
        if(!element.tableId) {
          element.tableId = that.tableId;
        }
        if(!element.pageId) {
          element.pageId = that.pageId;
        }
        element.isCustomSet = 1;
        toHtData.jsonStr = JSON.stringify(element);
        element.triggerId = element.directButtonSetId;
        that.tableObjectloading = true;
        utils.request(that,{
          url: url, 
          data: toHtData,
          success: function (res) {
            console.log(res.data);
            element.triggerId = res.data;
            element.directButtonSetId = res.data;
            element.ifSaveSuccess = true;
            that.saveAfterDirectId();
          }
        })
      })
      
    },
    saveAfterDirectId(){
      var that = this;
      var tmpDirectButtonIdStr = "";
      var ifSaveCom = true;
      that.directButtonSetValue.directSetList.forEach(element => {
        if(element.ifSaveSuccess && element.directButtonSetId > 0) {
          tmpDirectButtonIdStr+=","+element.directButtonSetId;
        } else {
          ifSaveCom = false;
        }
      })
      console.log("ifSaveCom======================",ifSaveCom,that.directButtonSetValue.directSetList);
      if(ifSaveCom) {
        that.value[that.fieldOne.enName] = tmpDirectButtonIdStr;
        this.addDialogFlag = false;
      }
    },
    //显示新增页面按钮
    showAddPage() {
      var that = this;
      this.addPageInfo.ifShow = !this.addPageInfo.ifShow;
      //名称自动拼接的规则 如果是添加页面
      // if(this.fieldOne.type == 14) {
        var typeName = "列表";
        //添加页面
        if(this.fieldOne.loadPageType == 5) {
          typeName = "添加"
        } else if(this.fieldOne.loadPageType == 7){
          typeName = "修改"
        } else if(this.fieldOne.loadPageType == 11){
          typeName = "查看"
        } else if(this.fieldOne.loadPageType == 16) {
          typeName = "下拉树"
        } else if(this.fieldOne.loadPageType == 15) {
          typeName = "弹出层"
        }
        var addPageName = this.fieldOne.addPageName?this.fieldOne.addPageName:(this.fieldOne.filterEnName?this.fieldOne.filterEnName:"lgName");
        console.log("this.value---------------------",this.fieldOne,this.value,addPageName);
        // (this.value.lgName?this.value.lgName:this.value[this.fieldOne.filterEnName].fieldCnName)
        //新增添加页面
        this.addPageInfo.pageName = this.pageName + "-" + (this.value[this.fieldOne.addPageName]?this.value[this.fieldOne.addPageName]:"") + "-" + typeName;
      // }
    },
    //新增页面保存
    addNewPage() {
      //调用页面新增的保存 成功之后再进行页面选中
      var that = this;
      var url = "object_createPage.do";
      // tableId=101&pageType=5&isInterface=0&isCreateMenu=1&pageName=%E7%9B%98%E7%82%B9%E5%8D%95%E6%B7%BB%E5%8A%A0-%E6%B5%8B%E8%AF%95&parentId=&parentName=&pMenuId=&parentMenu=&pMenuName=
      var toHtData = {};
      toHtData.tableId = that.addPageInfo.tableId;
      toHtData.pageType = that.addPageInfo.pageType;
      toHtData.isInterface=0;
      toHtData.isCreateMenu=0;
      toHtData.pageName=that.addPageInfo.pageName;
      toHtData.parentId="";
      toHtData.parentName="";
      toHtData.pMenuId="";
      toHtData.parentMenu="";
      toHtData.pMenuName="";
      that.addPageInfo.loading = true;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          // that.value[that.fieldOne.enName] = res.data;
          that.$set(that.value,that.fieldOne.enName,res.data);
          that.objectArr.unshift({
            pageId:res.data,
            pageName:toHtData.pageName,
            value:res.data,
            text:toHtData.pageName
          });
          that.addPageInfo.loading = false;
        },
        error:function(){
          that.addPageInfo.loading = false;
        }
      })
      //addPageInfo.pageName
      this.addPageInfo.ifShow = !this.addPageInfo.ifShow;
    },
    //加载子表格的页面设置信息
    loadChildPageObject(){
      var that = this;
      console.log("外键字段==================",that.value,that.tableId);
      var dataId = that.value[that.fieldOne.enName];
      if(dataId > 0) {
        var toHtData = {};
        toHtData.mongoName = "page";
        toHtData.mongoIdName = "pageId";
        toHtData.sourceType = 1;
        var url = "pageShowSet_loadMongoInfoById.do";
        toHtData.dataId = dataId;
        that.tableObjectloading = true;
        utils.request(that,{
          url: url, 
          data: toHtData,
          success: function (res) {
            console.log(res.data);
            var tmpJson = {};
            if(res.data) {
                tmpJson = res.data;
            }
            that.childPageInfo=tmpJson;
            that.childPageInfo.ifLoad = true;
            if(!that.childPageInfo.relationTableId>0) {
              that.childPageInfo.relationTableId = that.value[that.fieldOne.filterEnName][that.fieldOne.filterFieldEnName];
            }
            that.childPageInfo.pageDiaLogId = that.value.pageDialog;
            that.tableObjectloading = false;
          }
        })
      } else {
        if(that.value[that.fieldOne.filterEnName]) {
          that.childPageInfo.relationTableId = that.value[that.fieldOne.filterEnName][that.fieldOne.filterFieldEnName];
          //如果tableId跟当前主表tableId相同 则使用relationTableId 不同则使用tableId
          
          if(that.value[that.fieldOne.filterEnName].tableId == that.tableId) {
            that.childPageInfo.tableId = that.value[that.fieldOne.filterEnName].relationTableId;
          } else {
            that.childPageInfo.tableId = that.value[that.fieldOne.filterEnName].tableId;
          }
        } else {
          console.log("that.value.fieldObj==================",that.value.fieldObj);
          that.childPageInfo.tableId = that.value.fieldObj.relationTableId;
        }
        that.childPageInfo.pageDiaLogId = that.value.pageDialog;
        that.childPageInfo.ifLoad = true;
      }
    },
    //保存子页面
    saveChildPage(){
      var that = this;
      var toHtData = {};
      toHtData.mongoName = "page";
      toHtData.mongoIdName = "pageId";
      toHtData.sourceType = 1;
      var dataId = that.value[that.fieldOne.enName];
      if(dataId > 0) {
        toHtData.dataId = dataId;
      }
      if(that.childPageInfo.pageId == 0) {
        delete that.childPageInfo["pageId"];
      }
      toHtData.jsonStr = JSON.stringify(that.childPageInfo);
      var url = "pageShowSet_saveMongoInfoById.do";
      that.tableObjectloading = true;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          that.value[that.fieldOne.enName] = res.data;
          //
          that.tableObjectloading = false;
          that.openSetChildPage();
        }
      })
    },
    plChangeIfDelete(){
      var that = this;
      var nowArr = that.value[that.fieldOne.enName];
      console.log("nowArr====111===========",nowArr);
      if(nowArr) {
        nowArr.forEach(element => {
          that.$set(element,that.fieldOne.fieldArr[1].enName,that.ifDelete);
          // element[that.fieldOne.fieldArr[1].enName] = that.ifDelete;
        });
      }
      console.log("nowArr====222===========",nowArr);
      that.$forceUpdate();
    },
    //打开关闭子表格设置
    openSetChildPage(){
      this.addChildPageFlag = !this.addChildPageFlag;
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-col{min-height: 41px;padding: 3px}
</style>
